/* eslint-disable prettier/prettier */
enum ROLES {
  STUDENT = 'Student',
  ADMIN = 'Admin',
  USER = 'User'
}

export default ROLES;
